export enum Protocols {
    HTTP = 'http:',
    HTTPS = 'https:',
    FTP = 'ftp:',
    SFTP = 'sftp:',
    WS = 'ws:',
    WSS = 'wss:',
    STOMP = 'stomp:',
    AMQP = 'amqp:',
    MQTT = 'mqtt:'
}
